import axiosInstance from "@/api/axios"

const IS_UAT = import.meta.env.MODE === "uat-s3"
const IS_PROD = import.meta.env.MODE === "prod"

type UseChangeLineParams = {
  shouldLoadJBLScript: Ref<boolean>
  hasMountedJBL: Ref<boolean>
  loadJBLScript: () => Promise<void>
  initJBLWebSocket: (domain: string) => Promise<void>
  fetchRecommendLine: () => Promise<string>
}

const useChangeLine = ({
  shouldLoadJBLScript,
  hasMountedJBL,
  loadJBLScript,
  initJBLWebSocket,
  fetchRecommendLine
}: UseChangeLineParams) => {
  const webSiteInfoStore = useWebsiteInfoStore()
  const { lines, state: websiteInfo } = storeToRefs(webSiteInfoStore)

  const webSiteDomain = computed(() => window.location.hostname.replace(/^[^.]+\./g, ""))

  const prevChangeLine = ref<string | undefined>(undefined)

  const isEnableLoginChangeLine = computed(() => websiteInfo.value.enableLoginChangeLine)

  const isEnableChangeLine = computed(() => {
    if (websiteInfo.value.webSiteDisplayName === "BETKHALAMS") return false

    if (IS_UAT || IS_PROD) return isEnableLoginChangeLine.value

    return false
  })

  const currentAPIUrl = computed(() => {
    if (IS_UAT || IS_PROD) return window.location.host
    return ""
  })

  const updateBaseUrl = (line: string) => {
    axiosInstance.defaults.baseURL = `${window.location.protocol}//${line}`
  }

  const updateChangeLine = (line: string) => {
    prevChangeLine.value = line
  }

  useChangeLineCore({
    webSiteDomain,
    lines,
    prevChangeLine,
    isEnableChangeLine,
    currentAPIUrl,
    updateChangeLine,
    updateBaseUrl,
    shouldLoadJBLScript,
    hasMountedJBL,
    loadJBLScript,
    initJBLWebSocket,
    fetchRecommendLine
  })
}

export default useChangeLine
